import {
  all,
  call,
  put,
  select,
  takeEvery,
  takeLatest,
  takeLeading
} from 'redux-saga/effects';

import { customerId } from 'common/helpers/tokenHelper';
import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';
import { LIST_CLUB_MEMBER_SHIPMENTS_SUCCESS } from 'redux/clubMemberShipments/constants';
import { getVirtualCart as getVirtualCartForTraditionalShipment } from 'redux/clubMemberShipments/sagas';
import { getClubPackage } from 'redux/clubPackages/api';
import { LIST_CLUB_PACKAGES_SUCCESS } from 'redux/clubPackages/constants';
import { LIST_CLUB_SUBSCRIPTION_SHIPMENTS_SUCCESS } from 'redux/clubSubscriptionShipments/constants';
import { getVirtualCart as getVirtualCartForSubscriptionShipment } from 'redux/clubSubscriptionShipments/sagas';
import { LIST_CLUBS_SUCCESS } from 'redux/clubs/constants';

import {
  addClubMembershipHold,
  cancelClubMembership,
  editClubMembership,
  editClubMembershipHold,
  getClubMembership,
  getNextShipment,
  listClubMemberships
} from './api';
import {
  ADD_CLUB_MEMBERSHIP_HOLD_REQUEST,
  CANCEL_CLUB_MEMBERSHIP_REQUEST,
  CLUB_MEMBERSHIP_LIST_REQUESTING,
  CLUB_MEMBERSHIP_OBJECT_REQUESTING,
  EDIT_CLUB_MEMBERSHIP_HOLD_REQUEST,
  EDIT_CLUB_MEMBERSHIP_REQUEST,
  GET_CLUB_MEMBERSHIP_REQUEST,
  GET_CLUB_MEMBERSHIP_SUCCESS,
  LIST_CLUB_MEMBERSHIPS_REQUEST,
  LIST_CLUB_MEMBERSHIPS_SUCCESS,
  RESET_CLUB_MEMBERSHIP_ISFETCHING
} from './constants';

function* list(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_LIST_REQUESTING });

    const v2Response = yield call(
      listClubMemberships,
      customerId(),
      action.queryString
    );
    yield call(
      listPayloadV2,
      v2Response.data.data,
      v2Response.data.total || v2Response.data.data.length,
      customerId()
    );
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* listPayloadV2(payloadV2, total, customerId) {
  const traditionalClubNextShipment = yield call(
    listNextTraditionalClubShipments,
    payloadV2,
    customerId
  );
  const subscriptionClubNextShipment = yield call(
    listNextSubscriptionClubShipments,
    payloadV2,
    customerId
  );
  yield call(updateClubs, payloadV2);

  const transformedData = yield call(
    transformDataForMembership,
    payloadV2,
    total,
    traditionalClubNextShipment.clubPackageMap,
    traditionalClubNextShipment.clubMemberShipmentsMap,
    subscriptionClubNextShipment.clubSubscriptionShipmentMap
  );

  yield put({
    type: LIST_CLUB_MEMBERSHIPS_SUCCESS,
    payload: transformedData
  });
}

function* transformDataForMembership(
  clubMemberships,
  total,
  clubPackageMap,
  clubMemberShipmentsMap,
  clubSubscriptionShipmentMap
) {
  const transformClubMemberships = clubMemberships.map((clubMembership) => {
    if (clubPackageMap[clubMembership.id]) {
      clubMembership.activeClubPackageId = clubPackageMap[clubMembership.id];
    }
    if (clubMemberShipmentsMap[clubMembership.id]) {
      clubMembership.activeClubMemberShipmentId =
        clubMemberShipmentsMap[clubMembership.id];
    }
    if (clubSubscriptionShipmentMap[clubMembership.id]) {
      clubMembership.activeClubSubscriptionShipmentId =
        clubSubscriptionShipmentMap[clubMembership.id];
    }
    return clubMembership;
  });
  return {
    data: transformClubMemberships,
    total: total
  };
}

function* listNextTraditionalClubShipments(clubMemberships, customerId) {
  const clubMemberShipments = [];
  const clubPackages = [];
  const clubPackageMap = {};
  const clubMemberShipmentsMap = {};
  const activeTraditionalMembershipsForCustomer = clubMemberships.filter(
    (clubMembership) => {
      return (
        clubMembership.status === 'Active' &&
        (clubMembership.clubType === 'Traditional' ||
          clubMembership.clubType === 'Controlled Subscription')
      );
    }
  );

  for (const clubMembership of activeTraditionalMembershipsForCustomer) {
    const response = yield call(getNextShipment, customerId, clubMembership.id);

    if (response.data.clubMemberShipment) {
      clubMemberShipments.push(response.data.clubMemberShipment);
      clubMemberShipmentsMap[clubMembership.id] =
        response.data.clubMemberShipment.id;
    }
    if (
      response.data.clubMemberShipment &&
      response.data.clubMemberShipment.clubPackageId
    ) {
      const clubPackageId = response.data.clubMemberShipment.clubPackageId;
      clubPackageMap[clubMembership.id] = clubPackageId;

      const clubPackageResponse = yield call(getClubPackage, clubPackageId);
      if (clubPackageResponse.data) {
        clubPackages.push(clubPackageResponse.data);
      }
    }
  }

  if (clubMemberShipments.length > 0) {
    yield put({
      type: LIST_CLUB_MEMBER_SHIPMENTS_SUCCESS,
      payload: { clubMemberShipments }
    });
  }

  yield put({
    type: LIST_CLUB_PACKAGES_SUCCESS,
    payload: { clubPackages }
  });

  return { clubPackageMap, clubMemberShipmentsMap };
}

function* listNextSubscriptionClubShipments(clubMemberships, customerId) {
  const clubSubscriptionShipments = [];
  const clubSubscriptionShipmentMap = {};
  const activeSubscriptionMembershipsForCustomer = clubMemberships.filter(
    (clubMembership) =>
      clubMembership.status === 'Active' &&
      clubMembership.club.type === 'Subscription'
  );

  for (const clubMembership of activeSubscriptionMembershipsForCustomer) {
    const response = yield call(getNextShipment, customerId, clubMembership.id);
    if (response.data.clubSubscriptionShipment) {
      clubSubscriptionShipmentMap[clubMembership.id] =
        response.data.clubSubscriptionShipment.id;
      clubSubscriptionShipments.push(response.data.clubSubscriptionShipment);
    }
  }

  if (clubSubscriptionShipments.length > 0) {
    yield put({
      type: LIST_CLUB_SUBSCRIPTION_SHIPMENTS_SUCCESS,
      payload: { clubSubscriptionShipments }
    });
  }
  return { clubSubscriptionShipmentMap };
}

function* updateClubs(clubMemberships) {
  const clubs = [];
  clubMemberships.forEach((clubMembership) => {
    if (clubMembership.club) {
      clubs.push(clubMembership.club);
    }
  });
  yield put({
    type: LIST_CLUBS_SUCCESS,
    payload: { data: clubs }
  });
}

function* get(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_OBJECT_REQUESTING });
    const v2Response = yield call(
      getClubMembership,
      action.clubMembershipId,
      customerId()
    );

    yield call(updateClubs, [v2Response.data]);
    const traditionalClubNextShipment = yield call(
      listNextTraditionalClubShipments,
      [v2Response.data],
      customerId()
    );
    const subscriptionClubNextShipment = yield call(
      listNextSubscriptionClubShipments,
      [v2Response.data],
      customerId()
    );

    const transformedData = yield call(
      transformDataForMembership,
      [v2Response.data],
      1,
      traditionalClubNextShipment.clubPackageMap,
      traditionalClubNextShipment.clubMemberShipmentsMap,
      subscriptionClubNextShipment.clubSubscriptionShipmentMap
    );

    yield put({
      type: GET_CLUB_MEMBERSHIP_SUCCESS,
      payload: transformedData.data[0]
    });
    return transformedData.data[0];
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    return null;
  }
}

function* edit(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_OBJECT_REQUESTING });
    yield call(
      editClubMembership,
      customerId(),
      action.clubMembershipId,
      action.data
    );
    const newMembership = yield call(get, {
      clubMembershipId: action.clubMembershipId
    });

    if (action.onSuccess) {
      const clubMemberShipment = yield select(
        (state) =>
          state.clubMemberShipment.data?.[
            newMembership?.activeClubSubscriptionShipmentId ||
              newMembership?.activeClubMemberShipmentId
          ]
      );

      // get virtual cart if it is subscription shipment
      // and order is not completed yet
      if (
        newMembership?.activeClubSubscriptionShipmentId &&
        clubMemberShipment?.processingStatus !== 'Completed'
      ) {
        yield call(getVirtualCartForSubscriptionShipment, {
          clubSubscriptionShipmentId:
            newMembership.activeClubSubscriptionShipmentId
        });
      }
      // get virtual cart if it is traditional shipment
      // and order is not completed yet
      if (
        newMembership?.activeClubMemberShipmentId &&
        clubMemberShipment?.processingStatus !== 'Completed'
      ) {
        yield call(getVirtualCartForTraditionalShipment, {
          clubMemberShipmentId: newMembership.activeClubMemberShipmentId
        });
      }

      action.onSuccess(newMembership);
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* cancel(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_OBJECT_REQUESTING });
    yield call(
      cancelClubMembership,
      customerId(),
      action.clubMembershipId,
      action.data
    );
    const newMembership = yield call(get, {
      clubMembershipId: action.clubMembershipId
    });

    if (action.onSuccess) {
      action.onSuccess(newMembership);
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* addHold(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_OBJECT_REQUESTING });
    yield call(
      addClubMembershipHold,
      customerId(),
      action.clubMembershipId,
      action.data
    );
    const newMembership = yield call(get, {
      clubMembershipId: action.clubMembershipId
    });
    if (action.onSuccess) {
      action.onSuccess(newMembership);
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* editHold(action) {
  try {
    yield call(removeAPIError);
    yield call(
      editClubMembershipHold,
      customerId(),
      action.clubMembershipId,
      action.id,
      action.data
    );
    const newMembership = yield call(get, {
      clubMembershipId: action.clubMembershipId
    });
    if (action.onSuccess) {
      action.onSuccess(newMembership);
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* watchList() {
  yield takeLeading(LIST_CLUB_MEMBERSHIPS_REQUEST, list);
  yield takeLatest(GET_CLUB_MEMBERSHIP_REQUEST, get);
  yield takeEvery(EDIT_CLUB_MEMBERSHIP_REQUEST, edit);
  yield takeLatest(CANCEL_CLUB_MEMBERSHIP_REQUEST, cancel);
  yield takeLatest(ADD_CLUB_MEMBERSHIP_HOLD_REQUEST, addHold);
  yield takeLatest(EDIT_CLUB_MEMBERSHIP_HOLD_REQUEST, editHold);
}

export default function* clubMembershipSagas() {
  yield all([watchList()]);
}
